import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { ErrorMessage, Field, FormikProvider, useFormik, FieldArray } from 'formik';
import * as Yup from "yup";
import { config } from '../../../CommonUtilities/CommonUrl/CommonUrls';
import { CommonAxiosGet, CommonAxiosPost } from '../../../CommonUtilities/CommonAxios/CommonAxios';
import { BsEye } from 'react-icons/bs';
import { viewImage } from '../../../CommonUtilities/CommonFileUpload/ViewImage';
import ImageBucket from '../../../CommonUtilities/CommonFileUpload/ImageBucket';
import { ERROR_MSG, handleKeyPressNumeric } from '../../../CommonUtilities/Validations/RegularExpAndVar';
import { CommonPageHeading } from '../../../CommonUtilities/CommonHeading/CommonPageHeading';
import CasteDetails from './CasteDetails';
import { useSelector } from 'react-redux';
import Sweetalert from '../../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import Swal from 'sweetalert2';
import { FaCheck } from 'react-icons/fa';
// import { BiTrash } from 'react-icons/bi';

export default function FileUploads() {

    const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);

    const [showAcademicData, setAcademicData] = useState([]);
    const [AdditionalData, setAdditionalData] = useState([]);
    const [particulars, SetParticulars] = useState([]);
    const [AdditionalFlag, setaddlDatastatus] = useState(false)
    const [showOtpBtn, setOtpBtn] = useState(true);
    const [resendOtp, setResendOtp] = useState(false);

    const [regData, setRegData] = useState()

    const [timer, setTimer] = useState(180); // Timer in seconds
    useEffect(() => {
        let interval = null;
        if (!showOtpBtn) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer > 0) {
                        if (prevTimer < 122) {
                            setResendOtp(true);
                            return prevTimer - 1;
                        } else if (prevTimer > 1) {
                            return prevTimer - 1;
                        }
                        else {
                            clearInterval(interval);
                            setResendOtp(true); // Enable resend button when timer reaches 0
                            return 0;
                        }
                    }
                });
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [showOtpBtn]);

    const formatTime = (timeInSeconds) => {
        if (isNaN(timeInSeconds) || timeInSeconds < 0) {
            return "0:00";
        }
        const minutes = Math.floor(timeInSeconds / 60);
        const seconds = timeInSeconds % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    const resendOTP = () => {
        Formik.setFieldValue("otp", "")
        let values = Formik?.values
        sendOtp(values)
    };



    const userValidationSchema = Yup.object().shape({
        certificateId: Yup.string().when(['regCaste'], {
            is: (caste) => (caste === 'OC' || Formik?.values?.is_andhra === 'false'),
            then: Yup.string().nullable(),
            otherwise: Yup.string().nullable().required(ERROR_MSG)
        }),
        certificateCaste: Yup.string().when(['regCaste'], {
            is: (caste) => (caste === 'OC' || Formik?.values?.is_andhra === 'false'),
            then: Yup.string().nullable(),
            otherwise: Yup.string().nullable().required(ERROR_MSG)
        }),
        candidateDocs: Yup.array().of(
            Yup.object().shape({
                uploadDoc: Yup.mixed().required(ERROR_MSG)
            })
        ),
        additionalDocs: Yup.array().of(
            Yup.object().shape({
                uploadDoc: Yup.mixed().required(ERROR_MSG)
            })
        ),
        studyParticularsDocs: Yup.array().of(
            Yup.object().shape({
                fromDate: Yup.string()
                    .required(ERROR_MSG)
                    .test(
                        "default-value",
                        null,
                        function (value, context) {
                            if (context.parent && context.from && context.from[0] && context.from[0].value === 0) {
                                return true;
                            }
                            return !!value;
                        }
                    ),
                toDate: Yup.string()
                    .required(ERROR_MSG)
                    .test(
                        "valid-range",
                        "To Class must be equal to or greater than From Class",
                        (value, context) => {
                            const { fromDate } = context.parent;
                            if (!value) {
                                return false; // Required rule handles empty case
                            }

                            const actualFromDate = fromDate || "4";

                            try {
                                const fromValue = parseInt(String(actualFromDate).trim(), 10);
                                const toValue = parseInt(String(value).trim(), 10);

                                // ✅ Check if both are valid integers
                                if (isNaN(fromValue) || isNaN(toValue)) {
                                    return context.createError({
                                        message: "required",
                                    });
                                }

                                // ✅ Check the range condition
                                return toValue >= fromValue;
                            } catch (error) {
                                console.error("Validation error:", error);
                                return false;
                            }
                        }
                    ),
                uploadDoc: Yup.mixed().required(ERROR_MSG),
            })
        )
    });
    function uploadDataFunction() {
        let linkurl = config.url.DSC_URL + 'candidate-docs';
        CommonAxiosGet(linkurl).then((response) => {
            if (response?.data?.CandidateDetails_status === true) {
                let reg_data = response?.data?.CandidateDetails[0]
                setRegData(reg_data)
                Formik.setFieldValue('certificateId', reg_data?.certificate_id);
                Formik.setFieldValue('certificateCaste', reg_data?.certificate_caste);
                Formik.setFieldValue('certificateSubCaste', reg_data?.certificate_sub_caste);
                Formik.setFieldValue('regCaste', reg_data?.caste);
                Formik.setFieldValue('is_andhra', reg_data?.is_andhra ? 'true' : 'false')
            }

            SetParticulars(response?.data?.particularDocs_status ? response?.data?.particularDocs : []);
            setAcademicData(response?.data?.data_status ? response?.data?.data : []);
            setAdditionalData(response?.data?.addlData_status ? response?.data?.addlData : [])
            setaddlDatastatus(response?.data?.addlData_status)

        });
    }
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            regCaste: regData?.caste,
            is_andhra: regData?.is_andhra ? 'true' : 'false',
            certificateId: "",
            certificateCaste: "",
            certificateSubCaste: "",
            candidateDocs: [],
            studyParticularsDocs: [
                {
                    fromDate: 4,
                    toDate: "",
                    docType: "",
                    uploadDoc: ""
                }
            ],
            additionalDocs: []
        },
        validationSchema: userValidationSchema,

        onSubmit: (values) => {
            handleFormSubmit(values)
        },

    });
    function handleFormSubmit(values) {
        if (values?.selfCheck) {
            sendOtp(values);
        } else {
            Sweetalert('Please confirm the declaration to proceed.', 'warning');
        }
    }
    function sendOtp(values) {
        Swal.fire({
            title: 'Are you Sure Want to Submit?',
            html: `Make Sure , OTP will be Send to <span style="color: blue;">${loginreducer?.mobile_no}</span>`, icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Send OTP",
        }).then((res) => {
            if (res.isConfirmed) {
                let otpUrl = config.url.DSC_URL + "generate-uploads-otp"
                CommonAxiosPost(otpUrl, values).then((rres) => {
                    if (rres?.data?.status === true) {
                        setOtpBtn(false)
                        setTimer(180);
                    }
                    else if (rres?.data?.scode === '03') {
                        Sweetalert(rres?.data?.sdesc, "warning")

                    } else {
                        Sweetalert(rres?.data?.sdesc, "warning")
                    }

                })
            }
        })
    }
    function submitValues() {
        const candidateDocs = Formik.values.candidateDocs?.map((doc) => ({
            docId: doc.docId,
            studyType: doc.studyType,
            uploadDoc: doc.uploadDoc
        }));

        const studyParticularsDocs = Formik.values.studyParticularsDocs?.map((school) => ({
            docType: school.fromDate === school.toDate ? `${school.fromDate}` : `${school.fromDate}-${school.toDate}`,
            uploadDoc: school.uploadDoc
        }));

        const additionalDocs = Formik.values.additionalDocs?.map((doc) => ({
            docType: doc.docType,
            uploadDoc: doc.uploadDoc
        }));

        const payload = {
            certificateId: Formik.values.certificateId,
            certificateCaste: Formik.values.certificateCaste,
            certificateSubCaste: Formik.values.certificateSubCaste,
            otp: Formik.values.otp,
            candidateDocs,
            studyParticularsDocs,
            additionalDocs
        };
        let url = config.url.DSC_URL + 'candidate-docs';
        CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.status === true) {
                setOtpBtn(true);
                Formik.setFieldValue("otp", "");
                Formik.setFieldValue("selfCheck", "")
                Sweetalert('Successfully Submitted', 'success');
                uploadDataFunction();
            } else {
                Formik.setFieldValue("otp", "")
                Sweetalert(res?.data?.sdesc ? res?.data?.sdesc : 'Unauthorized Access! Please Login', "error");
            }
        });
    }


    useEffect(() => { uploadDataFunction() }, []);

    function studySETTING() {
        if (particulars?.length > 0) {
            let ad_data = particulars || [];
            const formattedDocs = ad_data?.map((val) => {
                let from = 4;
                let to = '';
                const docType = val?.doc_type || '';

                if (docType.includes('-')) {
                    const dates = docType.split('-');
                    from = parseInt(dates[0], 10);
                    to = parseInt(dates[1], 10);
                } else {
                    from = parseInt(docType, 10);
                    to = parseInt(docType, 10);
                }
                return {
                    fromDate: from,
                    toDate: to,
                    docType: docType,
                    uploadDoc: val?.upload_doc || ""
                };
            });

            Formik.setFieldValue("studyParticularsDocs", formattedDocs);
        }

    }
    function candidateSETTING() {
        if (showAcademicData?.length > 0) {
            let ac_data = showAcademicData || [];
            const candidateDocs = ac_data?.map((val) => {
                return {
                    docId: val?.id,
                    uploadDoc: val?.upload_doc ? val?.upload_doc : "",
                    studyType: val?.study_type
                }
            })
            Formik.setFieldValue("candidateDocs", candidateDocs);
        }

    }
    function additionSETTING() {
        if (AdditionalData?.length > 0) {
            let ac_data = AdditionalData || [];
            const adddDocs = ac_data?.map((val) => {
                return {
                    docId: val?.id,
                    docType: val?.doc_type,
                    uploadDoc: val?.upload_doc ? val?.upload_doc : "",
                }
            })
            Formik.setFieldValue("additionalDocs", adddDocs);
        }

    }
    useEffect(() => { candidateSETTING() }, [showAcademicData]);
    useEffect(() => { studySETTING() }, [particulars]);
    useEffect(() => { additionSETTING() }, [AdditionalData]);

    return (
        <React.Fragment>
            <CommonPageHeading heading="Upload Candidate Documents" />
            <FormikProvider value={Formik}>
                <Form className="form-section" onSubmit={Formik.handleSubmit}>

                    {(regData?.is_andhra === true) && (<CasteDetails Formik={Formik} showOtpBtn={showOtpBtn} />)}
                    <div className="personal-head mt-2"><span>Upload Academic Documents</span></div>
                    <div className="personal-row mb-3">
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped" style={{ borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th>Study Type</th>
                                        <th>Course</th>
                                        <th>Year of Pass</th>
                                        <th>Hall Ticket</th>
                                        <th>Percentage</th>
                                        <th>Upload Relevant Doc <span style={{ fontSize: 'small', color: 'red' }}>
                                            (Only .jpg, .jpeg, or .pdf files under 1 MB are allowed.)*
                                        </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {showAcademicData?.length > 0 ? <>
                                        {showAcademicData?.map((qual, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{qual?.study_type}</td>
                                                    <td>{qual?.course ? qual?.course : "-"}</td>
                                                    <td>{qual?.yop ? qual?.yop : "-"}</td>
                                                    <td>{qual?.hall_ticket ? qual?.hall_ticket : "-"}</td>
                                                    <td>{qual?.percentage ? qual?.percentage : "-"}</td>
                                                    <td> <Form.Group>
                                                        <div className="d-flex align-items-center">
                                                            {showOtpBtn === true && <input
                                                                type="file"
                                                                className="form-control"
                                                                name={`candidateDocs[${index}].uploadDoc`}
                                                                onChange={(e) => {
                                                                    ImageBucket(e, Formik, `candidateDocs[${index}].uploadDoc`, `candidateDocs_${qual?.study_type}_${qual?.id}`)
                                                                }}
                                                            />}
                                                            {(Formik?.values?.candidateDocs[index]?.uploadDoc || qual?.upload_doc) && (
                                                                <Button
                                                                    type="button"
                                                                    className="btn btn-primary ms-2 p-2 pt-1"
                                                                    onClick={() => { viewImage(Formik?.values?.candidateDocs[index]?.uploadDoc || qual?.upload_doc) }}
                                                                >
                                                                    <BsEye />
                                                                </Button>
                                                            )}
                                                        </div>
                                                        <Field type="hidden" name={`candidateDocs[${index}].uploadDocname`} />
                                                        <ErrorMessage name={`candidateDocs[${index}].uploadDoc`} component="div" className="text-error" />
                                                    </Form.Group>
                                                        {/* } */}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </> : <tr><td colSpan={7} className='text-danger text-center'><small > ***** No Data Found *****</small></td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {AdditionalFlag && (<>
                        <div className="personal-head mt-2"><span>Upload Additional Documents</span></div>
                        <div className="personal-row mb-3">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped" style={{ borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Document Name</th>
                                            <th>Upload Document <span style={{ fontSize: 'small', color: 'red' }}>
                                                (Only .jpg, .jpeg, or .pdf files under 1 MB are allowed.)*
                                            </span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AdditionalData?.map((doc, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{doc?.doc_type ? doc?.doc_type : "-"}</td>

                                                    <td>

                                                        <Form.Group>
                                                            <div className="d-flex align-items-center">
                                                                {showOtpBtn === true &&
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        name={`additionalDocs[${index}].uploadDoc`}
                                                                        onChange={(e) => {
                                                                            ImageBucket(e, Formik, `additionalDocs[${index}].uploadDoc`, `additionalDocs_${doc?.doc_type}`);
                                                                        }} />}

                                                                {(Formik?.values?.additionalDocs[index]?.uploadDoc || doc?.upload_doc) && (
                                                                    <Button
                                                                        type="button"
                                                                        className="btn btn-primary ms-2 p-2 pt-1"
                                                                        onClick={() => {
                                                                            viewImage(Formik?.values?.additionalDocs[index]?.uploadDoc || doc?.upload_doc);
                                                                        }}
                                                                    >
                                                                        <BsEye />
                                                                    </Button>
                                                                )}
                                                            </div>
                                                            <Field type="hidden" name={`additionalDocs[${index}].uploadDocname`} />
                                                            <ErrorMessage name={`additionalDocs[${index}].uploadDoc`} component="div" className="text-error" />
                                                        </Form.Group>

                                                    </td>

                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div></>)}
                    <div className="personal-head mt-2"><span>Schooling Details</span></div>
                    <div className="personal-row mb-3">
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped" style={{ borderCollapse: 'collapse' }}>
                                <FieldArray
                                    name="studyParticularsDocs"
                                    render={({ push, remove }) => (
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr> <th>S.No.</th>
                                                    <th>From Class</th>
                                                    <th>To Class</th>
                                                    <th>Upload Document</th>
                                                    {/* <th>Action</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Formik.values.studyParticularsDocs.map((doc, index) => (
                                                    <tr key={index}>
                                                        {/* From Class */}
                                                        <td>{index + 1} .</td>
                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`studyParticularsDocs[${index}].fromDate`}
                                                                className="form-control"
                                                                disabled
                                                                value={Formik.values.studyParticularsDocs[index]?.fromDate || ""}
                                                            >
                                                                <option value="">Select</option>
                                                                {[...Array(10)].map((_, i) => (
                                                                    <option key={i} value={i + 1}>
                                                                        {i + 1}
                                                                    </option>
                                                                ))}
                                                            </Field>
                                                        </td>

                                                        {/* To Class */}
                                                        <td>
                                                            <Field
                                                                as="select"
                                                                name={`studyParticularsDocs[${index}].toDate`}
                                                                className="form-control"
                                                                value={Formik.values.studyParticularsDocs[index]?.toDate || ""}
                                                                disabled={showOtpBtn === false}
                                                                onChange={(e) => {
                                                                    const value = parseInt(e.target.value, 10);
                                                                    const currentFromDate =
                                                                        Formik.values.studyParticularsDocs[index]?.fromDate || 4;

                                                                    Formik.setFieldValue(
                                                                        `studyParticularsDocs[${index}].toDate`,
                                                                        value
                                                                    );
                                                                    Formik.setFieldValue(
                                                                        `studyParticularsDocs[${index}].docType`,
                                                                        currentFromDate === value
                                                                            ? `${value}`
                                                                            : `${currentFromDate}-${value}`
                                                                    );

                                                                    const nextFromDate = value + 1;

                                                                    for (
                                                                        let i = Formik.values.studyParticularsDocs.length - 1;
                                                                        i > index;
                                                                        i--
                                                                    ) {
                                                                        remove(i);
                                                                    }

                                                                    if (value < 10) {
                                                                        push({
                                                                            fromDate: nextFromDate,
                                                                            toDate: "",
                                                                            docType: "",
                                                                            uploadDoc: "",
                                                                        });
                                                                    }
                                                                }}
                                                            >
                                                                <option value="">Select Class</option>
                                                                {Array.from({ length: 11 - (Formik.values.studyParticularsDocs[index]?.fromDate || 4) }, (_, idx) => {
                                                                    const classValue = (Formik.values.studyParticularsDocs[index]?.fromDate || 4) + idx;
                                                                    return (
                                                                        <option key={classValue} value={classValue} disabled={classValue < doc.fromDate}>
                                                                            {`${classValue}th Class`}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </Field>
                                                            <ErrorMessage name={`studyParticularsDocs[${index}].toDate`} component="div" className="text-danger" />
                                                        </td>

                                                        {/* Upload Document */}
                                                        <td> <div className="d-flex align-items-center">
                                                            {showOtpBtn === true && <input
                                                                type="file"
                                                                className="form-control"
                                                                name={`studyParticularsDocs[${index}].uploadDoc`}
                                                                onChange={(e) => {
                                                                    ImageBucket(
                                                                        e,
                                                                        Formik,
                                                                        `studyParticularsDocs[${index}].uploadDoc`,
                                                                        `studyParticularsDocs`
                                                                    );
                                                                }}
                                                            />}
                                                            {Formik.values.studyParticularsDocs[index]?.uploadDoc && (
                                                                <Button
                                                                    type="button"
                                                                    className="btn btn-primary ms-2 p-2 pt-1"
                                                                    onClick={() => {
                                                                        viewImage(
                                                                            Formik.values.studyParticularsDocs[index]?.uploadDoc
                                                                        );
                                                                    }}
                                                                >
                                                                    <BsEye />
                                                                </Button>
                                                            )}</div>
                                                            <ErrorMessage name={`studyParticularsDocs[${index}].uploadDoc`} component="div" className="text-danger" />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                />


                            </table>
                        </div>
                    </div>

                    <Row className='pb-0 pt-2 mx-0'>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className='alert alert-warning'> &nbsp;
                            {showOtpBtn === false ? <FaCheck color="green" /> : <Field
                                type="checkbox"
                                name="selfCheck"
                                className="form-sub"
                                onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    Formik.setFieldValue('selfCheck', isChecked ? true : null);
                                }}
                            />} &nbsp;I Hereby ,declare that  all the above information is correct to the best of my knowledge.
                            <ErrorMessage
                                name="selfCheck"
                                component="div"
                                className="text-error"
                            /> </Col>
                    </Row>
                    <Row className='pb-4'>
                        <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                            {showOtpBtn === true ?
                                <Button variant="secondary" type="submit" className="bg-dark submit-btn mt-4 " >
                                    Generate OTP </Button>
                                : showOtpBtn === false ?
                                    <React.Fragment>
                                        {resendOtp === false ?
                                            <Form.Label className="input-lable mb-3 mt-4">OTP Sent to &nbsp;
                                                <b className='text-primary'>{loginreducer?.mobile_no} </b></Form.Label> :
                                            resendOtp === true ? <React.Fragment>
                                                <Form.Label className="input-lable mt-2">Didn't receive code? </Form.Label>
                                                <Button variant="primary" type="button" className="submit-btn"
                                                    onClick={() => { resendOTP() }}>Resend OTP </Button></React.Fragment>

                                                : ''
                                        }
                                    </React.Fragment> : ''}
                        </Col>
                        {showOtpBtn === false ? <React.Fragment>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                                <Form.Label className="input-lable mb-3 mt-4">Time Remaining:  {formatTime(timer)}</Form.Label>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3}>
                                <Form.Group controlId="otp">
                                    <Field
                                        type="text"
                                        name="otp"
                                        // onChange={(e) => { handleKeyPressNumeric(e) }}
                                        className="input-field form-control mt-4"
                                        placeholder="Enter OTP"
                                        maxLength={6}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} xxl={3} className='pt-2' >
                                <Button type="button" className="btn btn-success" onClick={() => { submitValues() }}>
                                    Submit Details
                                </Button>
                            </Col>
                        </React.Fragment> : ''}
                    </Row>




                </Form>
            </FormikProvider>
        </React.Fragment>
    );
}
